var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '@emotion/styled';
// only used when backgroundColor is passed as a prop (custom button colors?)
var ButtonOverlay = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: ", "px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 100%;\n  width: 100%;\n  background: rgba(255, 252, 246, 0.2);\n  transition: opacity 0.3s ease-in-out;\n  opacity: 0;\n\n  &:hover {\n    opacity: 1;\n  }\n"], ["\n  border-radius: ", "px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 100%;\n  width: 100%;\n  background: rgba(255, 252, 246, 0.2);\n  transition: opacity 0.3s ease-in-out;\n  opacity: 0;\n\n  &:hover {\n    opacity: 1;\n  }\n"])), function (_a) {
    var br = _a.br;
    return br;
});
export default ButtonOverlay;
var templateObject_1;
